import * as React from "react";
import { initCookieConsent } from "@/core/lib/cookie-consent";
import { CookieBanner } from "./cookie-banner";
import { CookiePreferencesDialog } from "./cookie-preferences-dialog";

/**
 * Mounts the consent engine and its (entirely custom) UI. Rendered once from the
 * root layout so the banner is available on the sign-in screen, the dashboard
 * and the employee portal alike.
 *
 * The engine boot is client-only and idempotent, so the effect is safe under
 * strict mode's double invocation; nothing renders until it resolves.
 */
export function CookieConsentProvider() {
  React.useEffect(() => {
    void initCookieConsent();
  }, []);

  return (
    <>
      <CookieBanner />
      <CookiePreferencesDialog />
    </>
  );
}
